export default "__VITE_ASSET__DlZukaZl__"